import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-simple-tree-unfold",
  "use": "app-icon-simple-tree-unfold-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"app-icon-simple-tree-unfold\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 .5h16v16H0z\" /><path d=\"M13.5 2a1 1 0 011 1v11a1 1 0 01-1 1h-11a1 1 0 01-1-1V3a1 1 0 011-1h11zm0 1h-11v11h11V3zM11 8a.5.5 0 010 1H5a.5.5 0 010-1h6z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol